import CONFIG from './config';

const API_ENDPOINT = {
  DATA: `${CONFIG.BASE_URL}`,
};

export default API_ENDPOINT;
